<div class="flex flex-row justify-between items-center search-container">
  <input type="text" class="fw-400 h-34 no-border" (keyup)="onKeyUp($event)"
		placeholder="{{ 'SEARCH.PLACE_HOLDER' | transloco }}">
  <mat-icon svgIcon="search" class="mr-16 icon-sm"></mat-icon>
</div>
